/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Vinh's Portfolio",
  description:
    "A passionate individual who always thrives to work on end to end products.",
  og: {
    title: "Nguyen Thanh Vinh Portfolio",
    type: "website",
    url: "https://profile-2f38d.web.app",
  },
};

//Home Page
const greeting = {
  title: "Nguyen Thanh Vinh",
  logo_name: "Nguyen Thanh Vinh",
  nickname: "",
  subTitle:
    "A passionate individual who always thrives to work on end to end products.",
  resumeLink: "https://123job.vn/cv/preview/804c3e3720d3a277b2601c2ddb3ab589",
  portfolio_repository: "https://github.com/vnvstore",
  githubProfile: "https://github.com/vnvstore",
};

const socialMediaLinks = [
  /* Your Social Media Link */
  // github: "https://github.com/ashutosh1919",
  // linkedin: "https://www.linkedin.com/in/ashutosh-hathidara-88710b138/",
  // gmail: "ashutoshhathidara98@gmail.com",
  // gitlab: "https://gitlab.com/ashutoshhathidara98",
  // facebook: "https://www.facebook.com/laymanbrother.19/",
  // twitter: "https://twitter.com/ashutosh_1919",
  // instagram: "https://www.instagram.com/layman_brother/"

  {
    name: "Github",
    link: "https://github.com/vnvstore",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/nguyen-t-vinh/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },

  {
    name: "Gmail",
    link: "mailto:vappstore2016@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },

  /*
  {
    name: "Github",
    link: "https://github.com/ashutosh1919",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/ashutosh1919/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "YouTube",
    link: "https://youtube.com/c/DevSense19",
    fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
    backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  },
  {
    name: "Gmail",
    link: "mailto:ashutoshhathidara98@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  {
    name: "Twitter",
    link: "https://twitter.com/ashutosh_1919",
    fontAwesomeIcon: "fa-twitter", // Reference https://fontawesome.com/icons/twitter?style=brands
    backgroundColor: "#1DA1F2", // Reference https://simpleicons.org/?q=twitter
  },
  {
    name: "Facebook",
    link: "https://www.facebook.com/laymanbrother.19/",
    fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
    backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  },
  {
    name: "Instagram",
    link: "https://www.instagram.com/layman_brother/",
    fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
    backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  },
  */
];

const skills = {
  data: [
    /* testing
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing highly scalable production ready models for various deeplearning and statistical use cases",
        "⚡ Experience of working with Computer Vision and NLP projects",
        "⚡ Complex quantitative modelling for dynamic forecasting and time series analysis",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "PyTorch",
          fontAwesomeClassname: "logos-pytorch",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
      ],
    },
    */
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Languages: Flutter, Dart, objective C, android, Python, PHP, SQL, HTML/CSS, JavaScript, Java, C#, NodeJS, ReactJS",
        "⚡ Databases: Isar, MySQL, SQLite, Firebase Databases, MongoDB",
        "⚡ Web Technologies: Apache, Nginx, DirectAdmin, Npm",
        "⚡ Design Tools: Figma, Adobe Photoshop",
        "⚡ Cloud Developer Tools: GCP, AWS, Azure, Appwrite",
        "⚡ Technologies/Frameworks: Docker, Centos, VMware, GitHub, Firebase",
      ],
      softwareSkills: [
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
        {
          skillName: ".Net MAUI",
          fontAwesomeClassname: "devicon:csharp",
          style: {
            color: "#02569B",
          },
        },

        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            color: "#7378aa",
          },
        },

        {
          skillName: "Centos",
          fontAwesomeClassname: "simple-icons:centos",
          style: {
            color: "#915185",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#e99d3f",
          },
        },

        {
          skillName: "Azure",
          fontAwesomeClassname: "devicon:azure-wordmark",
          style: {
            color: "#e99d3f",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "logos:aws",
          style: {
            color: "#e99d3f",
          },
        },
        {
          skillName: "Appwrite",
          fontAwesomeClassname: "devicon:appwrite-wordmark",
          style: {
            color: "#e99d3f",
          },
        },

        {
          skillName: "Nginx",
          fontAwesomeClassname: "simple-icons:nginx",
          style: {
            color: "#3f8b43",
          },
        },
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Sass",
          fontAwesomeClassname: "simple-icons:sass",
          style: {
            color: "#CC6699",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "skill-icons:nodejs-light",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
      ],
    },
    {
      title: "Cloud Infra-Architecture",
      fileName: "CloudInfraImg",
      skills: [
        "⚡ Hosting and maintaining websites on Centos along with integration of databases",
        "⚡ Experience working on multiple cloud platforms",
        "⚡ Setting up streaming jobs from DB to Server or vice-versa on GCP",
      ],
      softwareSkills: [
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },

        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#e99d3f",
          },
        },

        {
          skillName: "Azure",
          fontAwesomeClassname: "devicon:azure-wordmark",
          style: {
            color: "#e99d3f",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "logos:aws",
          style: {
            color: "#e99d3f",
          },
        },
        {
          skillName: "Appwrite",
          fontAwesomeClassname: "devicon:appwrite-wordmark",
          style: {
            color: "#e99d3f",
          },
        },

        {
          skillName: "Centos",
          fontAwesomeClassname: "simple-icons:centos",
          style: {
            color: "#915185",
          },
        },

        {
          skillName: "Nginx",
          fontAwesomeClassname: "simple-icons:nginx",
          style: {
            color: "#3f8b43",
          },
        },

        /*
        {
          skillName: "GCP",
          fontAwesomeClassname: "simple-icons:googlecloud",
          style: {
            color: "#4285F4",
          },
        },
        {
          skillName: "AWS",
          fontAwesomeClassname: "simple-icons:amazonaws",
          style: {
            color: "#FF9900",
          },
        },
        {
          skillName: "Azure",
          fontAwesomeClassname: "simple-icons:microsoftazure",
          style: {
            color: "#0089D6",
          },
        },
        {
          skillName: "Firebase",
          fontAwesomeClassname: "simple-icons:firebase",
          style: {
            color: "#FFCA28",
          },
        },
        {
          skillName: "PostgreSQL",
          fontAwesomeClassname: "simple-icons:postgresql",
          style: {
            color: "#336791",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Docker",
          fontAwesomeClassname: "simple-icons:docker",
          style: {
            color: "#1488C6",
          },
        },
        {
          skillName: "Kubernetes",
          fontAwesomeClassname: "simple-icons:kubernetes",
          style: {
            color: "#326CE5",
          },
        },
        */
      ],
    },
    /*
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF7C00",
          },
        },
        {
          skillName: "Inkscape",
          fontAwesomeClassname: "simple-icons:inkscape",
          style: {
            color: "#000000",
          },
        },
      ],
    },
    */
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Microsoft Developer Badges",
      iconifyClassname: "mdi:microsoft-azure",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://learn.microsoft.com/en-us/users/vinhnt/",
    },

    {
      siteName: "Google Developer Badges",
      iconifyClassname: "logos:google-cloud",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://developers.google.com/profile/u/vappstore2016",
    },
    {
      siteName: "Upwork Skill Certifications",
      iconifyClassname: "logos:upwork",
      style: {
        color: "#F79F1B",
      },
      profileLink:
        "https://drive.google.com/file/d/1cGXdAaxXAju1TEMWhqt9Vbz0pKTK1uMB/view?pli=1",
    },

    {
      siteName: "CodeSignal",
      iconifyClassname: "simple-icons:appsignal",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://app.codesignal.com/profile/t_vinh_n/badges",
    },

    {
      siteName: "LeetCode",
      iconifyClassname: "simple-icons:leetcode",
      style: {
        color: "#F79F1B",
      },
      profileLink: "https://leetcode.com/vappstore2016/",
    },

    /*
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/layman_brother",
    },
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/ashutosh_1919",
    },
    {
      siteName: "Codeforces",
      iconifyClassname: "simple-icons:codeforces",
      style: {
        color: "#1F8ACB",
      },
      profileLink: "http://codeforces.com/profile/layman_brother",
    },
    {
      siteName: "Hackerearth",
      iconifyClassname: "simple-icons:hackerearth",
      style: {
        color: "#323754",
      },
      profileLink: "https://www.hackerearth.com/@ashutosh391",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/laymanbrother",
    },
    */
  ],
};

const degrees = {
  degrees: [
    {
      title: "The St.Petersburg Polytechnic University",
      subtitle: "Master of Science in Engineering",
      logo_path: "logo_saint.png",
      alt_name: "SPbPU",
      duration: "2003 - 2009",
      descriptions: [
        "⚡ I got fully funded scholarship from Vietnamse Government",
        "⚡ The university excels in computer science education",
        "⚡ I studied the fundamentals of computer science",
      ],
      website_link: "https://english.spbstu.ru/",
    },
    /*
    {
      title: "Indian Institute of Information Technology Kurnool",
      subtitle: "B.Tech. in Computer Engineering",
      logo_path: "iiitk_logo.png",
      alt_name: "IIITDM Kurnool",
      duration: "2016 - 2020",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, DBMS, OS, CA, AI etc.",
        "⚡ Apart from this, I have done courses on Deep Learning, Data Science, Cloud Computing and Full Stack Development.",
        "⚡ I was selected for Merit cum Means Scholarship which is given to top 10% of students in college. I have received award from respected director for consistently best performance in academics.",
      ],
      website_link: "http://iiitk.ac.in",
    },
    {
      title: "Indiana University Bloomington",
      subtitle: "M.S. in Computer Science",
      logo_path: "iu_logo.png",
      alt_name: "Indiana University Bloomington",
      duration: "2021 - 2023",
      descriptions: [
        "⚡ I have taken varity of courses related to Artificial Intelligence which correspond to Explainable AI, Graph Machine Learning, Computer Vision etc.",
        "⚡ Apart from this, I have also done research assistantship. As part of it, I have worked on creating new algorithms in Graph ML and Network Science.",
        "⚡ During my time at university, I was also associated with multimedia department. As part of it, I have worked on some documentry films and interviews.",
      ],
      website_link: "https://www.indiana.edu/",
    },
    */
  ],
};

const certifications = {
  //Javascript
  certifications: [
    {
      title: "Full-Stack Engineering with JavaScript",
      subtitle: "- CodeSignal",
      logo_path: "certificate_fullstack.png",
      certificate_link:
        "https://codesignal.com/learn/certificates/cm162d38100dbdh7q5v3bzq31/course-paths/14",
      alt_name: "CodeSignal",
      color_code: "#FFFFFFFF",
    },

    //Python
    {
      title: "Programming Foundations with Python",
      subtitle: "- CodeSignal",
      logo_path: "certificate_python.jpg",
      certificate_link:
        "https://codesignal.com/learn/certificates/cm162d38100dbdh7q5v3bzq31/courses/99",
      alt_name: "CodeSignal",
      color_code: "#FFFFFFFF",
    },
    {
      title: "Introduction to Simple Data Structures in Python",
      subtitle: "- CodeSignal",
      logo_path: "certificate_python_1.jpeg",
      certificate_link:
        "https://codesignal.com/learn/certificates/cm162d38100dbdh7q5v3bzq31/courses/100",
      alt_name: "CodeSignal",
      color_code: "#FFFFFFFF",
    },

    //Kotlin
    {
      title: "Kotlin Programming for Beginners",
      subtitle: "- CodeSignal",
      logo_path: "certificate_kotlin.jpeg",
      certificate_link:
        "https://codesignal.com/learn/certificates/cm162d38100dbdh7q5v3bzq31/courses/100",
      alt_name: "CodeSignal",
      color_code: "#FFFFFFFF",
    },

    {
      title: "General Coding Assessment",
      subtitle: "- CodeSignal",
      logo_path: "certificate_codesignal.png",
      certificate_link:
        "https://drive.google.com/file/d/1PE6CdoLYOB0FdX5Z-x_qqWPZqmJ9AG0O/view?usp=drive_link",
      alt_name: "CodeSignal",
      color_code: "#8C151599",
    },

    {
      title: "Upwork Java Android Test",
      subtitle: "- Upwork",
      logo_path: "certificate_upwork.png",
      certificate_link:
        "https://drive.google.com/file/d/1N23JHHVZ6GhCsLY_SqMmYwHuKktUlLrh/view",
      alt_name: "Upwork",
      color_code: "#0C9D5899",
    },

    {
      title: "Microsoft Developer Badges",
      subtitle: "- Microsoft",
      logo_path: "certificate_microsoft.png",
      certificate_link: "https://learn.microsoft.com/en-us/users/vinhnt/",
      alt_name: "Microsoft Developer Badges",
      color_code: "#ff9cebff",
    },
    {
      title: "Google Developer Badges",
      subtitle: "- Google",
      logo_path: "certificate_google.png",
      certificate_link: "https://developers.google.com/profile/u/vappstore2016",
      alt_name: "Google Developer Badges",
      color_code: "#ffebdebb",
    },

    {
      title: "Bitrix Certificate",
      subtitle: "- Bitrix24",
      logo_path: "certificate_bitrix.jpeg",
      certificate_link:
        "https://drive.google.com/file/d/1USdLij8XM8t7Sdp0ZnZgIxAefNngEazC/view?usp=sharing",
      alt_name: "Bitrix24",
      color_code: "#1F70C199",
    },

    /*
   
    {
      title: "Machine Learning",
      subtitle: "- Andrew Ng",
      logo_path: "stanford_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/22MTSSC5WDTM",
      alt_name: "Stanford University",
      color_code: "#8C151599",
    },
    {
      title: "Deep Learning",
      subtitle: "- Andrew Ng",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/H8CPSFXAJD2G",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/EB4VJARK8647",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "Data Science",
      subtitle: "- Alex Aklson",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/specialization/PLEAPCSJBZT5",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Big Data",
      subtitle: "- Kim Akers",
      logo_path: "microsoft_logo.png",
      certificate_link:
        "https://drive.google.com/file/d/164zKCFOsI4vGqokc-Qj-e_D00kLDHIrG/view",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Advanced Data Science",
      subtitle: "- Romeo Kienzler",
      logo_path: "ibm_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/BH2T9BRU87BH",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Advanced ML on GCP",
      subtitle: "- GCP Training",
      logo_path: "google_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/5JZZM7TNQ2AV",
      alt_name: "Google",
      color_code: "#0C9D5899",
    },
    {
      title: "DL on Tensorflow",
      subtitle: "- Laurence Moroney",
      logo_path: "deeplearning_ai_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/verify/6T4DCUGNK8J8",
      alt_name: "deeplearning.ai",
      color_code: "#00000099",
    },
    {
      title: "Fullstack Development",
      subtitle: "- Jogesh Muppala",
      logo_path: "coursera_logo.png",
      certificate_link:
        "https://www.coursera.org/account/accomplishments/certificate/NRANJA66Y2YA",
      alt_name: "Coursera",
      color_code: "#2A73CC",
    },
    {
      title: "Kuberenetes on GCP",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/e4d5a92b-faf6-4679-a70b-a9047c0cd750",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    {
      title: "Cryptography",
      subtitle: "- Saurabh Mukhopadhyay",
      logo_path: "nptel_logo.png",
      certificate_link:
        "https://drive.google.com/open?id=1z5ExD_QJVdU0slLkp8CBqSF3-C3g-ro_",
      alt_name: "NPTEL",
      color_code: "#FFBB0099",
    },
    {
      title: "Cloud Architecture",
      subtitle: "- Qwiklabs",
      logo_path: "gcp_logo.png",
      certificate_link:
        "https://google.qwiklabs.com/public_profiles/5fab4b2d-be6f-408c-8dcb-6d3b58ecb4a2",
      alt_name: "GCP",
      color_code: "#4285F499",
    },
    */
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  //description:"I have worked with many evolving startups as ML and DL Developer, Designer and Software Architect. I have also worked with some well established companies mostly as AI Developer. I love organising events and that is why I am also involved with many opensource communities as a representative.",
  description:
    "I'm a software engineer with more than 12 years of experience developing Web and Mobile Apps. ",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Senior Mobile Developer",
          company: "Interactive Partners (Australia)",
          company_url: "https://interactivepartners.com.au/",
          logo_path: "logo_interactivepartners.png",
          duration: "2023 - Present",
          location: "Australia",
          description:
            "I am key developer of a large mobile project for American client - Homesphere.",
          color: "#0879bf",
        },

        {
          title: "Web and Mobile Team Leader",
          company: "Vivicorp (Vietnam)",
          company_url: "https://vivicorp.com/",
          logo_path: "logo_vv.png",
          duration: "2015 - 2023",
          location: "Danang, Vietnam",
          description:
            "I am technical team leader of many large web and mobile projects.",
          color: "#0879bf",
        },
        {
          title: "Mobile App Developer",
          company: "FPT Software (Vietnam)",
          company_url: "https://www.fpt-software.com/our-campus/danang/",
          logo_path: "logo_fsoft.png",
          duration: "2012 - 2014",
          location: "Danang, Vietnam",
          description:
            "I am the key developer of Mobile Team to develop Applications for American Clients such as Copart. I got experience working on large and complex projects.",
          color: "#9b1578",
        },
        {
          title: "iOS Game Developer",
          company: "MileStone Inc. (Japan)",
          company_url: "https://en.wikipedia.org/wiki/MileStone_Inc.",
          logo_path: "logo_milestone.png",
          duration: "2010 - 2011",
          location: "Japan",
          description:
            "I studied object C language from start and made the iOS game called 'Train a Go Go'. I experienced the real time start up.",
          color: "#fc1f20",
        },
        {
          title: "Website Developer",
          company: "Webuspeh (Russia)",
          company_url: "https://webuspeh.ru/",
          logo_path: "logo_webuspeh.jpg",
          duration: "March 2009 - September 2009",
          location: "Russia",
          description:
            "Website development using PHP, Html, CSS and Javascript",
          color: "#fc1f20",
        },

        /*
        {
          title: "Associate AI Engineer",
          company: "Legato Health Technology",
          company_url: "https://legatohealthtech.com/",
          logo_path: "legato_logo.png",
          duration: "June 2020 - Aug 2021",
          location: "Hyderabad, Telangana",
          description:
            "I am working on automating healthcare products. The projects involve automation for process improvements and for significantly enhancing the profits. I am currently working on Cancer Survival and Reoccurence Prediction. Our goal is to make AI system which scales and removes doctor dependency as much as possible.",
          color: "#0879bf",
        },
        {
          title: "Android and ML Developer",
          company: "Muffito Incorporation",
          company_url: "https://www.linkedin.com/company/muffito-inc/about/",
          logo_path: "muffito_logo.png",
          duration: "May 2018 - Oct 2018",
          location: "Pune, Maharashtra",
          description:
            "I have created complete Android Application for locating Pub, Bar and beverage shops around you. I have also worked on implementation of algorithms for Face Detection, Text extraction from Image. I was involved in a team for creating complete software architecure of mobile and web application as well as admin panel for company.",
          color: "#9b1578",
        },
        {
          title: "Android Developer",
          company: "FreeCopy Pvt. Ltd.",
          company_url: "https://www.linkedin.com/company/freecopy/about/",
          logo_path: "freecopy_logo.png",
          duration: "Nov 2017 - Dec 2017",
          location: "Ahmedabad, Gujarat",
          description:
            "FreeCopy is the Start up from Indian Institute of Management, Ahmedabad. I have changed the integration of the whole app from Google to Firebase. I learnt the efﬁcient ways of Data communications like Retroﬁt, Eventbus etc. I experienced the real time start up. I learnt the Design thinking of UI on perspective of People.",
          color: "#fc1f20",
        },
        */
      ],
    },

    {
      title: "Internships",
      experiences: [
        {
          title: "Website Developer",
          company: "Webuspeh (Russia)",
          company_url: "https://webuspeh.ru/",
          logo_path: "logo_webuspeh.jpg",
          duration: "March 2009 - September 2009",
          location: "Saint Petersburg, Russia",
          description: "Website development using html, css and javascript.",
          color: "#000000",
        },

        /*
          {
            title: "Machine Learning Intern",
            company: "TikTok Inc.",
            company_url: "https://www.tiktok.com/en/",
            logo_path: "tiktok_logo.png",
            duration: "May 2022 - Aug 2022",
            location: "San Francisco, USA",
            description:
              "Building new features on the backend recommendation system, specifically ranking algorithms for Ads that touch hundreds of millions of people around the world. Improving online and offline content ranking algorithms by performing hard sample data replays for training steps.",
            color: "#000000",
          },
          {
            title: "Data Science Research Intern",
            company: "Delhivery Pvt. Ltd.",
            company_url: "https://www.delhivery.com/",
            logo_path: "delhivery_logo.png",
            duration: "May 2019 - Sept 2019",
            location: "Gurgaon, Haryana",
            description:
              "I have worked on project of predicting freight rates based on previous data. There were two objectives: (1) To build a forecasting engine to predict daily freight rates. (2) To embed feature in the model which can explain the seasonal major changes in freight rate based on regions and locations. I have closely worked with deep learning models in combination with statistical methods to create solution for this. At the end of internship, I had created model deployed on AWS EC2 with the use of Kafka stream jobs, ElasticSearch and PostgreSQL.",
            color: "#ee3c26",
          },
          {
            title: "Data Science Intern",
            company: "Intel Indexer LLC",
            company_url:
              "https://opencorporates.com/companies/us_dc/EXTUID_4170286",
            logo_path: "intel_logo.jpg",
            duration: "Nov 2018 - Dec 2018",
            location: "Work From Home",
            description:
              "This is financial Solution Company. I have made Supervised Learning model for the company which can perform time series analysis on Stock price data for 32 companies. I have built LSTM Neural Networks Model and trained the data of 32 companies for last 2 years. This model is also used for forecasting.",
            color: "#0071C5",
          },
         */
      ],
    },

    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Developer Program Member",
          company: "Github",
          company_url: "https://github.com/",
          logo_path: "github_logo.png",
          duration: "2020 - PRESENT",
          location: "Work From Home",
          description:
            "I am actively contributing to many opensource projects.",
          color: "#181717",
        },
        {
          title: "Google Cloud Skills Boost",
          company: "Google",
          company_url: "https://www.cloudskillsboost.google/",
          logo_path: "google_logo.png",
          duration: "2020 - PRESENT",
          location: "Work From Home",
          description:
            "Google Cloud Skills Boost is an online learning platform for Google Cloud and related skills: Associate Cloud Engineer, Professional Cloud Security Engineer,...",
          color: "#4285F4",
        },
        /*
         {
           title: "Google Explore ML Facilitator",
           company: "Google",
           company_url: "https://about.google/",
           logo_path: "google_logo.png",
           duration: "June 2019 - April 2020",
           location: "Hyderabad, Telangana",
           description:
             "Explore Machine Learning (ML) is a Google-sponsored program for university students to get started with Machine Learning. The curriculum offers 3 tracks of ML Content (Beginner, Intermediate, Advanced) and relies on university student facilitators to train other students on campus and to build opensource projects under this program.",
           color: "#4285F4",
         },
         {
           title: "Microsoft Student Partner",
           company: "Microsoft",
           company_url: "https://www.microsoft.com/",
           logo_path: "microsoft_logo.png",
           duration: "Aug 2019 - May 2020",
           location: "Hyderabad, Telangana",
           description:
             "Microsoft Student Partner is a program for university students to lead the awareness and use of Cloud especially Azure tools in the development of their projects and startups. Under this program, I have organised hands on workshops and seminars to teach Cloud Computing concepts to students.",
           color: "#D83B01",
         },
         {
           title: "Mozilla Campus Captain",
           company: "Mozilla",
           company_url: "https://www.mozilla.org/",
           logo_path: "mozilla_logo.png",
           duration: "Oct 2019 - May 2020",
           location: "Kurnool, Andhra Pradesh",
           description:
             "My responsibility for this program was to create opensource environment in college and in the city. We have organised multiple hackathons on the problems collected by ordinary people from Kurnool city. We have build opensource community of our own college. The community is available at dsc_iiitdmk on github.",
           color: "#000000",
         },
         {
           title: "Developer Students Club Member",
           company: "DSC IIITDM Kurnool",
           company_url:
             "https://www.linkedin.com/company/developer-students-club-iiitdm-kurnool",
           logo_path: "dsc_logo.png",
           duration: "Jan 2018 - May 2020",
           location: "Kurnool, Andhra Pradesh",
           description:
             "We have well established developer club in college which is directly associated with Google Developers. We have developed many interdisciplinary projects under the membership of this club. We have organised workshops and activities on Android Application Development, Flutter and React JS.",
           color: "#0C9D58",
         },
         {
           title: "Developer Program Member",
           company: "Github",
           company_url: "https://github.com/",
           logo_path: "github_logo.png",
           duration: "July 2019 - PRESENT",
           location: "Work From Home",
           description:
             "I am actively contributing to many opensource projects. I have contributed to projects of organisations like Tensorflow, Uber, Facebook, Google, Scikit-learn, Kiwix, Sympy, Python, NVLabs, Fossasia, Netrack, Keras etc. These contributions include bug fixes, feature requests and formulating proper documentation for project.",
           color: "#181717",
         },
         */
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  //description:"My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
  description:
    "I build innovative solutions using cutting-edge technologies, specializing in cross-platform mobile development with Flutter. Additionally, I have hands-on experience with AI tools like Google's Genkit and Vertex AI, integrating intelligent features into applications. Passionate about leveraging the latest tech trends, I thrive on creating seamless, smart, and user-centric experiences.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Publications",
  description:
    "I have worked on and published a few research papers and publications of my own.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzQ=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzi=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNze=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzt=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
    {
      id: "MDEwOlJlcG9zaXRvcnkyNDU0NjcyNzb=",
      name: "Artificial Intelligence Paper",
      createdAt: "2020-03-06T16:26:54Z",
      description: "Paper Written on Artificial Intelligence published in xyz ",
      url:
        "https://www.andrewng.org/publications/building-high-level-features-using-large-scale-unsupervised-learning/",
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "vinhnt_art.jpg",
    //description:"I am available on almost every social media. You can message me, I will reply within 24 hours. I can help you with ML, AI, React, Android, Cloud and Opensource Development.",
    description: "You can message me, I will reply within 24 hours.",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "For individual fundamental empowerment, I like to write powerful lessons that create impact on each of the reader individually to change the core of their character.",
    link: "https://blogs.ashutoshhathidara.com/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Da Nang city, Vietnam",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://goo.gl/maps/39LgH9h18xhf6U2dA",
  },
  phoneSection: {
    title: "",
    subtitle: "",
  },
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
};
